import { render } from "./AddColisDistrPage.vue?vue&type=template&id=0bd45b98&ts=true"
import script from "./AddColisDistrPage.vue?vue&type=script&lang=ts"
export * from "./AddColisDistrPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__